import { render } from "./FinancesVue.vue?vue&type=template&id=1218c458"
import script from "./FinancesVue.vue?vue&type=script&lang=js"
export * from "./FinancesVue.vue?vue&type=script&lang=js"

import "./FinancesVue.vue?vue&type=style&index=0&id=1218c458&lang=css"

import exportComponent from "/Users/janbergler/NPM/MPM/V3/mpm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__